/* eslint-disable camelcase */
import { loadJS } from 'utils/loadPlayerJSFiles';

// eslint-disable-next-line import/prefer-default-export
export function loadLitePlayerJSFiles(pageProps, cb) {
  const { apiKey, isFullPlayer } = pageProps;
  //  https://player-dev.sli.ke/4.0.0/cpl.light.js
  const url = isFullPlayer
    ? `https://tvid.in/r/spl.${apiKey}.js`
    : `https://tvid.in/r/spl.${apiKey}.light.js`;
  const loadPlayerJs = () => {
    Promise.all([loadJS(url, 'light_tvid_sdk_js', 'spl')]).then(() => {
      cb();
    });
  };
  loadPlayerJs();
}

export function setSlikeConfig(props, pageProps) {
  const {
    isPrime,
    divId,
    slikeId: id,
    mute = true,
    autoPlay = 2, // 1(ALLOWED), 2(WITH_MUTE), 3(NOT_ALLOWED)
    shareUrl,
    isVideoSkipAds,
    headless,
    sectionName: adSection,
    metakeywords: Meta_Keywords,
    bl: BL,
    skipAnalytics,
    videoInloop,
    volume = 70,
    midfreq,
    playInBackground = false,
    config = {},
    tmplSource,
    ui,
  } = props;
  const { apiKey } = pageProps;
  const { Tmpl_SCN: pageTpl, SCN: pageSection } = window?.Times?.adsKeys || {};
  let skipAd = isVideoSkipAds;
  if (isPrime) {
    skipAd = true;
  }
  const newPageTpl = pageTpl + (tmplSource ? `_${tmplSource}` : '');
  return {
    id,
    el: document.getElementById(divId),
    apiKey,
    controls: !headless,
    autoPlay,
    mute,
    skipModule: {
      skipAd,
      skipAnalytics,
      ...config.skipModule,
    },
    ui: ui || { scale: 1 },
    analytics: {
      pageSection,
      isPrime,
      pageUrl: window?.location?.href,
      pageTpl: newPageTpl,
      ...config.analytics,
    },
    callbacks: {
      onPlayerConfig: () => {
        const object = {
          ads: {
            adSection,
            preRollAdFiller: {
              enable: true,
              time: 7,
            },
            midfreq, //midRollAdBreak
            //  deferredPreroll: 7, will delay by this time
            params: {
              Meta_Keywords,
              BL,
            },
            ...config.onAdplayer,
          },
          player: {
            autoPlay,
            mute,
            isPrime,
            volume,
            shareUrl,
            loop: videoInloop,
            scroll: {
              view: 50,
            },
            // scrollBehaviour, not now
            // gestureControls, noot now
            playInBackground,
            ...config.onPlayer,
          },
        };
        return object;
      },
    },
    ...config.root,
  };
}

const playerEventTypeMap = {
  cplVideoCompleted: 'VIDEOCOMPLETE',
  cplPlayerReady: 'INIT',
  cplVideoStarted: 'VIDEOVIEW',
};

const adEventTypeMap = {
  cplAdComplete: 'ADCOMPLETE',
  cplAdSkip: 'ADSKIP',
  cplAdStart: 'ADSTART',
};

export function handleEvents(player, events, config) {
  function eventToFunction(eventName) {
    const mapEvent = playerEventTypeMap[eventName] || adEventTypeMap[eventName];
    if (typeof config?.outsideEventListener === 'function' && mapEvent) {
      config.outsideEventListener(mapEvent, player);
    }
  }
  Object.keys(events).forEach(eventKey => {
    const eventName = events[eventKey];
    player.on(eventName, eventToFunction.bind(null));
  });
}

export function playerErrorCallback(error, config) {
  if (typeof config?.playerErrorCallback === 'function') {
    config.playerErrorCallback(error);
  }
}
